import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { createStandaloneToast, theme } from '@frontend/components';
import { Text } from '@frontend/components';

import API from 'services/api';
import supplierSettingsService from 'services/supplierSettingsService';

import { getGroupId } from 'store/session/selectors';

import {
  deleteEmailTemplate,
  fetchEmailTemplates,
  fetchDefaultEmailTemplates,
  types,
  updateOrCreateEmailTemplate,
} from './actions';
import { EMAIL_TEMPLATE_TYPE_LABELS } from './constants';
import { getSelectedDefaultEmailTemplate } from './reducer';

const { toast } = createStandaloneToast({ theme });

export default function* root() {
  yield takeLatest(
    types.DELETE_EMAIL_TEMPLATE_REQUEST,
    watchDeleteEmailTemplate,
  ),
    yield takeLatest(
      types.UPDATE_OR_CREATE_EMAIL_TEMPLATE_REQUEST,
      watchUpdateOrCreateEmailTemplate,
    );
}

function* watchDeleteEmailTemplate(action) {
  try {
    const { templateId } = action.payload;
    yield call(API.supplier.deleteEmailTemplate, templateId);
    yield put(deleteEmailTemplate.success({ templateId }));
  } catch (error) {
    yield put(deleteEmailTemplate.error(error));
  }
}

function* watchFetchDefaultEmailTemplates() {
  try {
    const groupId = yield select(getGroupId);
    const response = yield call(
      supplierSettingsService.getDefaultEmailTemplates,
      groupId,
    );
    yield put(
      fetchDefaultEmailTemplates.success({ defaultEmailTemplates: response }),
    );
  } catch (error) {
    console.error('FAILED TO FETCH DEFAULT EMAIL TEMPLATES', error);
  }
}

function* watchFetchEmailTemplates() {
  try {
    const groupId = yield select(getGroupId);
    const response = yield call(API.supplier.getEmailTemplates, groupId);
    yield put(fetchEmailTemplates.success({ emailTemplates: response }));
  } catch (error) {
    console.error('FAILED TO FETCH EMAIL TEMPLATES', error);
  }
}

function* watchUpdateOrCreateEmailTemplate(action) {
  try {
    const oldDefaultTemplate = yield select(getSelectedDefaultEmailTemplate);
    const groupId = yield select(getGroupId);
    const data = action.payload;
    const response = data.id
      ? yield call(API.supplier.updateEmailTemplate, data.id, data)
      : yield call(API.supplier.createEmailTemplate, groupId, data);
    yield put(updateOrCreateEmailTemplate.success({ emailTemplate: response }));
    if (
      data.isDefault &&
      oldDefaultTemplate &&
      data.id !== oldDefaultTemplate?.id
    ) {
      yield call(toast, {
        status: 'info',
        description: (
          <>
            <Text as="span">
              {`The default ${
                EMAIL_TEMPLATE_TYPE_LABELS[data.templateType]
              } email template was changed from `}
            </Text>
            <Text as="span" fontWeight="heavy">
              {` ${oldDefaultTemplate?.title} `}
            </Text>
            <Text as="span">to</Text>
            <Text as="span" fontWeight="heavy">
              {` ${data.title}`}
            </Text>
          </>
        ),
      });
    }
  } catch (error) {
    yield put(updateOrCreateEmailTemplate.error(error));
  }
}

export function* initSaga() {
  yield all([
    call(watchFetchDefaultEmailTemplates),
    call(watchFetchEmailTemplates),
  ]);
}
